/** Stock Reconciliation — ledger vs balances, with rebuild. */
import { createFileRoute, redirect } from "@tanstack/react-router";
import { useAuth } from "@/features/auth/store";
import { ReconciliationPage } from "@/features/inventory/reconciliation/reconciliation-page";

export const Route = createFileRoute("/_app/inventory/reconciliation")({
  beforeLoad: () => {
    if (!useAuth.getState().can("inventory.reconcile"))
      throw redirect({ to: "/inventory" });
  },
  component: ReconciliationPage,
});
